import L from 'leaflet';
import LocaleService from '../services/LocaleService';

export default class MapSymbolGroup extends L.Marker
{
	// Mapping of facility IDs to icon keys
	static FACILITY_ICON_MAPPING = {
		1: 'info',
		2: 'wc',
		3: 'bf',
		4: 'ostomate',
		5: 'babybed',
		6: 'nursing',
		7: 'aed',
		8: 'elevator',
		9: 'phone',
		10: 'cafe',
		11: 'restaurant',
		12: 'wifi',
		13: 'restarea',
		14: 'smoking',
		15: 'restricted',
		16: 'backyard'
	};

	constructor(latlng, symbols, options = {})
	{
		super(latlng, 
		{
			pane: 'symbols'
		}
		);

		this.lang = options.lang || 'ja';
		this.initVars(options);

		this.addIcons(symbols, options);
	}

	initVars(options = {})
	{
	}

	addIcons(symbols, options = {})
	{
		const iconHtml = this.makeSymbols(symbols, options);

		const newIcon = L.divIcon({
			className: 'symbol-group',
			html: iconHtml,
			iconSize: L.point(30, 30),
		});
		
		this.setIcon(newIcon);
	}

	makeSymbols(symbols, options)
	{
		const container = L.DomUtil.create('div', 'symbol-items');

		if (symbols.ids.length > 2)
			container.setAttribute('data-colnum', symbols.colnum || 3);

		symbols.ids.forEach(item =>
		{
			container.appendChild(this.makeSymbol(item));
		}
		);

		return container.outerHTML;
	}

	makeSymbol(item)
	{
		const symbolElement = L.DomUtil.create('div', 'symbol-item');

		symbolElement.setAttribute('data-id', item.id);
		symbolElement.setAttribute('data-min-zoom', item.minZoom);

		if (item.maxZoom !== undefined)
		{
			symbolElement.setAttribute('data-max-zoom', item.maxZoom);
		}

		const iconKey = MapSymbolGroup.FACILITY_ICON_MAPPING[item.id];
		
		if (iconKey)
		{
			const img = L.DomUtil.create('img');
			img.src = `${process.env.PUBLIC_URL}/img/icon_${iconKey}.png`;
			symbolElement.appendChild(img);
		}
		else
		{
			// Fallback: create a placeholder if icon not found
			const placeholder = L.DomUtil.create('div');
			placeholder.className = 'symbol-placeholder';
			placeholder.textContent = item.id;
			symbolElement.appendChild(placeholder);
		}

		return symbolElement;
	}
}
